import { UPSERT_NOTE } from '../../constants/actions/policy';

export function upsertNote(payload) {
    return {
        type: UPSERT_NOTE,
        payload,
    };
}
